export default __webpack_public_path__ + "static/media/Powerful.55f5caea.svg";